// src/pages/Search/index.js
import React, { useState, useEffect, useMemo } from 'react';
import { useApp } from '../../context/AppContext';
// Removing the unused imports
// import { SearchHeader } from '../../components/layout/Header';
// import SalonCard from '../../components/ui/SalonCard';
import SearchScreen from './SearchScreen';
import SearchResults from './SearchResults';

const Search = () => {
  const { navigateTo, searchParams } = useApp();
  const [searchTerm, setSearchTerm] = useState('');
  const [searchMode, setSearchMode] = useState('results'); // 'screen' or 'results'
  
  // Sample salon data
  const salonData = useMemo(() => [
    {
      id: 1,
      name: "BARBERIA FOCȘANI",
      rating: 4.98,
      reviews: 484,
      address: "Strada Arhitect Ion Mincu, nr 10, bl. 10, sc. 1, Focșani",
      image: "/api/placeholder/100/100",
      distance: "1.4km",
      categories: ["barbershop", "haircut"]
    },
    {
      id: 2,
      name: "Frizerie cu Stil și Coafor Focșani",
      rating: 4.97,
      reviews: 430,
      address: "Bulevardul Brăilei nr 102 (Parcare Kaufland)",
      image: "/api/placeholder/100/100",
      distance: "2.1km",
      categories: ["hairstyling", "barbershop"]
    },
    {
      id: 3,
      name: "Black Arrogance",
      rating: 4.76,
      reviews: 70,
      address: "Strada Anghel Saligny nr 11, Liești",
      image: "/api/placeholder/100/100",
      distance: "30km",
      categories: ["barbershop"]
    }
  ], []);
  
  // Filtred salons based on search term and/or selected category
  const [filteredSalons, setFilteredSalons] = useState(salonData);
  
  // Listen for search params changes to update the search term
  useEffect(() => {
    if (searchParams && searchParams.searchTerm) {
      setSearchTerm(searchParams.searchTerm);
      setSearchMode('results');
    }
    
    // Check if we're in search screen mode
    if (searchParams && searchParams.mode === 'screen') {
      setSearchMode('screen');
    }
  }, [searchParams]);
  
  // Filter salons based on search term and/or selected category
  useEffect(() => {
    if (!searchTerm && !searchParams?.category) {
      setFilteredSalons(salonData);
      return;
    }
    
    let filtered = salonData;
    
    // Filter by search term
    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      filtered = filtered.filter(salon => 
        salon.name.toLowerCase().includes(term) || 
        salon.address.toLowerCase().includes(term) ||
        salon.categories.some(cat => cat.toLowerCase().includes(term))
      );
    }
    
    // Filter by category
    if (searchParams?.category) {
      filtered = filtered.filter(salon =>
        salon.categories.includes(searchParams.category)
      );
    }
    
    setFilteredSalons(filtered);
  }, [searchTerm, searchParams, salonData]);
  
  // Render the search screen or search results based on mode
  if (searchMode === 'screen') {
    return <SearchScreen />;
  }
  
  return <SearchResults 
    searchTerm={searchTerm} 
    onSearchChange={(e) => setSearchTerm(e.target.value)}
    filteredSalons={filteredSalons}
    navigateTo={navigateTo}
  />;
};

export default Search;